import DisasterPayment_Minimal from './DisasterPayment_Minimal'

const DisasterPaymentFragments = { DisasterPayment_Minimal }

export default DisasterPaymentFragments
